module.exports = __webpack_public_path__ + "img/CoCo.5454fa82.svg";